module.exports = __webpack_public_path__ + "static/noDataNo-98d8bb2aae77d605276e297427a2e545.png";